import React from 'react'
import { SVGProps } from 'react'

const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path d="M11.7158 10.2638L8.95694 7.50474C9.42569 6.75848 9.69775 5.87643 9.69775 4.92983C9.69775 2.25177 7.52673 0.0810547 4.84877 0.0810547C2.17082 0.0810547 0 2.25177 0 4.92983C0 7.60799 2.17071 9.7785 4.84877 9.7785C5.87892 9.7785 6.8331 9.45644 7.61826 8.90919L10.3443 11.6354C10.5337 11.8247 10.782 11.9189 11.0301 11.9189C11.2784 11.9189 11.5264 11.8247 11.7161 11.6354C12.0947 11.2565 12.0947 10.6427 11.7158 10.2638ZM4.84877 8.20757C3.03872 8.20757 1.57124 6.74019 1.57124 4.93003C1.57124 3.11987 3.03872 1.65239 4.84877 1.65239C6.65893 1.65239 8.12632 3.11987 8.12632 4.93003C8.12632 6.74019 6.65893 8.20757 4.84877 8.20757Z" />
    </g>
  </svg>
)
export default SearchIcon
